import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { StudentListModel } from "../../internship/studentlist/formmodel/studentlist.form.data.model";



export class StudentListGridModel extends StudentListModel {
    
 }

export class StudentListListingModel extends GridModel<StudentListGridModel> { 
    
}

export class StudentListGridParams extends GridPostParams {
    pageNumber: 1;
    pageSize: 10;
    search_text: '';
    direction: '';
    column: ''
}